import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _StreamID_type, _StreamID_cid;
import { CID } from 'multiformats/cid';
import * as Block from 'multiformats/block';
import { base36 } from 'multiformats/bases/base36';
import { sha256 as hasher } from 'multiformats/hashes/sha2';
import varint from 'varint';
import * as codec from '@ipld/dag-cbor';
import { concat as uint8ArrayConcat } from 'uint8arrays';
import { STREAMID_CODEC } from './constants.js';
import { readCidNoThrow, readVarint } from './reading-bytes.js';
import { Memoize } from 'typescript-memoize';
import { StreamType } from './stream-type.js';
function fromBytes(bytes) {
  var result = fromBytesNoThrow(bytes);
  if (result instanceof Error) {
    throw result;
  }
  return result;
}
function fromBytesNoThrow(bytes) {
  var _readVarint = readVarint(bytes),
    _readVarint2 = _slicedToArray(_readVarint, 2),
    streamCodec = _readVarint2[0],
    streamCodecRemainder = _readVarint2[1];
  if (streamCodec !== STREAMID_CODEC) return new Error('fromBytes: invalid streamid, does not include streamid codec');
  var _readVarint3 = readVarint(streamCodecRemainder),
    _readVarint4 = _slicedToArray(_readVarint3, 2),
    type = _readVarint4[0],
    streamTypeRemainder = _readVarint4[1];
  var cidResult = readCidNoThrow(streamTypeRemainder);
  if (cidResult instanceof Error) {
    return cidResult;
  }
  var _cidResult = _slicedToArray(cidResult, 2),
    cid = _cidResult[0],
    cidRemainder = _cidResult[1];
  if (cidRemainder.length > 0) {
    return new Error("Invalid StreamID: contains commit");
  }
  return new StreamID(type, cid);
}
function fromString(input) {
  var result = fromStringNoThrow(input);
  if (result instanceof Error) {
    throw result;
  }
  return result;
}
function fromStringNoThrow(input) {
  var protocolFree = input.replace('ceramic://', '').replace('/ceramic/', '');
  var commitFree = protocolFree.includes('commit') ? protocolFree.split('?')[0] : protocolFree;
  var bytes = base36.decode(commitFree);
  return fromBytesNoThrow(bytes);
}
var TAG = Symbol.for('@ceramicnetwork/streamid/StreamID');
export var StreamID = /*#__PURE__*/function (_ref, _Symbol$toPrimitive) {
  function StreamID(type, cid) {
    _classCallCheck(this, StreamID);
    this._tag = TAG;
    _StreamID_type.set(this, void 0);
    _StreamID_cid.set(this, void 0);
    if (!(type || type === 0)) throw new Error('constructor: type required');
    if (!cid) throw new Error('constructor: cid required');
    __classPrivateFieldSet(this, _StreamID_type, typeof type === 'string' ? StreamType.codeByName(type) : type, "f");
    __classPrivateFieldSet(this, _StreamID_cid, typeof cid === 'string' ? CID.parse(cid) : cid, "f");
  }
  _createClass(StreamID, [{
    key: "type",
    get: function get() {
      return __classPrivateFieldGet(this, _StreamID_type, "f");
    }
  }, {
    key: "typeName",
    get: function get() {
      return StreamType.nameByCode(__classPrivateFieldGet(this, _StreamID_type, "f"));
    }
  }, {
    key: "cid",
    get: function get() {
      return __classPrivateFieldGet(this, _StreamID_cid, "f");
    }
  }, {
    key: "bytes",
    get: function get() {
      var codec = varint.encode(STREAMID_CODEC);
      var type = varint.encode(this.type);
      return uint8ArrayConcat([codec, type, this.cid.bytes]);
    }
  }, {
    key: "baseID",
    get: function get() {
      return new StreamID(__classPrivateFieldGet(this, _StreamID_type, "f"), __classPrivateFieldGet(this, _StreamID_cid, "f"));
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (StreamID.isInstance(other)) {
        return this.type === other.type && this.cid.equals(other.cid);
      } else {
        return false;
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      return base36.encode(this.bytes);
    }
  }, {
    key: "toUrl",
    value: function toUrl() {
      return "ceramic://".concat(this.toString());
    }
  }, {
    key: _ref,
    value: function value() {
      return "StreamID(".concat(this.toString(), ")");
    }
  }, {
    key: _Symbol$toPrimitive,
    value: function value() {
      return this.toString();
    }
  }], [{
    key: "isInstance",
    value: function isInstance(instance) {
      return typeof instance === 'object' && '_tag' in instance && instance._tag === TAG;
    }
  }, {
    key: "fromGenesis",
    value: function () {
      var _fromGenesis = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type, genesis) {
        var block;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Block.encode({
                value: genesis,
                codec: codec,
                hasher: hasher
              });
            case 2:
              block = _context.sent;
              return _context.abrupt("return", new StreamID(type, block.cid));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function fromGenesis(_x, _x2) {
        return _fromGenesis.apply(this, arguments);
      }
      return fromGenesis;
    }()
  }]);
  return StreamID;
}((_StreamID_type = new WeakMap(), _StreamID_cid = new WeakMap(), Symbol.for('nodejs.util.inspect.custom')), Symbol.toPrimitive);
StreamID.fromBytes = fromBytes;
StreamID.fromBytesNoThrow = fromBytesNoThrow;
StreamID.fromString = fromString;
StreamID.fromStringNoThrow = fromStringNoThrow;
__decorate([Memoize(), __metadata("design:type", String), __metadata("design:paramtypes", [])], StreamID.prototype, "typeName", null);
__decorate([Memoize(), __metadata("design:type", Uint8Array), __metadata("design:paramtypes", [])], StreamID.prototype, "bytes", null);
__decorate([Memoize(), __metadata("design:type", StreamID), __metadata("design:paramtypes", [])], StreamID.prototype, "baseID", null);
__decorate([Memoize(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", String)], StreamID.prototype, "toString", null);
__decorate([Memoize(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", String)], StreamID.prototype, "toUrl", null);